import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import Card from '../Card/Card';
import BYOPIcon from '../../images/how-to-invest-build-portfolio.png';
import { generateGeneralTestID } from '../../generateAutomationTestIDs';

const BYOPCard = () => {
  const { next } = useContext(FlowContext);

  return (
    <Card
      id="card"
      icon={BYOPIcon}
      title="I'm comfortable selecting my own funds"
      subtitle="Add one or more mutual funds from our full list and customize your investment allocations"
      buttonText="Browse Mutual Funds"
      buttonFunction={next('byop')}
      buttonID={generateGeneralTestID('Card', 'BrowseAllFundsButton')}
      cardID={generateGeneralTestID('Card', 'BrowseAllFundsCard')}
    />
  );
};

export default BYOPCard;
